//import { useStore } from 'vuex'
import store from "../store/store";
//import { useI18n } from 'vue-i18n'
import { i18n } from './i18n'
import moment from "moment-mini";
import ExcellentExport from 'excellentexport';
import pdfmake from "pdfmake"
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import L from 'leaflet';




export function isUndefined(e) {
  return typeof e === "undefined";
}

export function randomIntFromInterval(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
export const CustomerInfo = {
  TimeZone: moment().utcOffset() / 60,
};

export function reverseArry (arry) {
  var newArry = [];
  var i = null;
  for (i = arry.length - 1; i >= 0; i -= 1) {
    newArry.push(arry[i]);
  }
  return newArry;
}

export function parsePlaybackHystoryArr (arry) {
  let self = this;
  let newArry = [];
  //var userInfo = app.methods.getFromStorage('userInfo');
        
  if (arry && arry.length) {
    for (var i = arry.length - 1; i >= 0; i--) {
      if (JSON.stringify(arry[i]) !== JSON.stringify(arry[i - 1])) {
        var index = 0;
        //console.log(arry[i][index++], moment(arry[i][index++],'DD/MM/YYYY HH:mm:ss') )
        //let newPosDateTime = moment(arry[i][index++],'DD/MM/YYYY HH:mm:ss').utc().add(userInfo.UserInfo.TimeZone, 'hours').add(app.data.UTCOFFSET,'minutes').format('DD/MM/YYYY HH:mm:ss');
               
        var point = {
          positionTime: arry[i][index++],
          lat: arry[i][index++],
          lng: arry[i][index++],
          direct: arry[i][index++],
          speed: arry[i][index++],
          timeSpan: arry[i][index++],
          mileage: arry[i][index++],
          alerts: arry[i][index++],
          status: arry[i][index++],
          noname1: arry[i][index++],
          noname2: arry[i][index++],
          alt: arry[i][index],//added
          battery: arry[i][index++],//added
          gps: arry[i][index++],
        };
        
        
        if(!point.lat.toString().includes('22.675') && !point.lng.toString().includes('113.972')){
          newArry.push(point);
        }
      }
    }
    newArry = reverseArry(newArry);
  }
  return newArry;
}
export function parsePlaybackEventsArr (arry) {
  let self = this;
  let newArry = [];
  if (arry && arry.length) {
    for (var i = arry.length - 1; i >= 0; i--) {
      if (JSON.stringify(arry[i]) !== 'null' && JSON.stringify(arry[i]) !== JSON.stringify(arry[i - 1])) {
    
        var index = 0;
        var point = {
          assetID: arry[i][index++],
          eventClass: arry[i][index++],
          eventType: arry[i][index++],
          state: arry[i][index++],
          otherCode: arry[i][index++],
          otherCode2: arry[i][index++],
          contactCode: arry[i][index++],
          beginTime: arry[i][index++],
          endTime: arry[i][index++],
          positionType: arry[i][index++],
          lat: arry[i][index++],
          lng: arry[i][index++],
          battery: arry[i][index],//added
          alt: arry[i][index++],//bat
          alerts: arry[i][index++],
          status: arry[i][index++],
          content: arry[i][index++],
        };
        if(!point.lat.toString().includes('22.675') && !point.lng.toString().includes('113.972')){
          newArry.push(point);
        }
      }
    }
    newArry = reverseArry(newArry);
  }
  return newArry;
}

export const Protocol = {
  // MarkerIcon: [
  //   { iconUrl: "../resources/images/marker.svg", iconSize: [32, 32] },
  //   { iconUrl: "../resources/images/marker2.svg", iconSize: [32, 32] },
  // ],
  MarkerIcon: [
		L.icon({
			iconUrl: '../resources/images/marker.svg',
			iconSize: [32, 32], // size of the icon
			iconAnchor: [17, 55], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -60] // point from which the popup should open relative to the iconAnchor
		}),
		L.icon({
			iconUrl: '../resources/images/marker2.svg',
			iconSize: [32, 32], // size of the icon
			iconAnchor: [17, 55], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -60] // point from which the popup should open relative to the iconAnchor
		}),
		L.icon({
			iconUrl: '../resources/images/marker3.svg',
			iconSize: [32, 32], // size of the icon
			iconAnchor: [20, 39], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -40] // point from which the popup should open relative to the iconAnchor
		}),
		L.icon({
			iconUrl: '../resources/images/info-pin.svg',
			iconSize: [32, 32], // size of the icon
			iconAnchor: [16, 31], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -32] // point from which the popup should open relative to the iconAnchor
		}),
		L.icon({
			iconUrl: '../resources/images/pin-alarm.svg',
			iconSize: [32, 32], // size of the icon
			iconAnchor: [16, 31], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -32] // point from which the popup should open relative to the iconAnchor
		}),
		L.icon({
			iconUrl: '../resources/images/pin-accon.svg',
			iconSize: [32, 32], // size of the icon
			iconAnchor: [16, 31], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -32] // point from which the popup should open relative to the iconAnchor
		}),
		L.icon({
			iconUrl: '../resources/images/pin-stopped.svg',
			iconSize: [32, 32], // size of the icon
			iconAnchor: [16, 31], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -32] // point from which the popup should open relative to the iconAnchor
		}),
		L.icon({
			iconUrl: '../resources/images/pin-out-geofence.svg',
			iconSize: [32, 32], // size of the icon
			iconAnchor: [16, 31], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -32] // point from which the popup should open relative to the iconAnchor
		}),
		L.icon({
			iconUrl: '../resources/images/pin-in-geofence.svg',
			iconSize: [32, 32], // size of the icon
			iconAnchor: [16, 31], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -32] // point from which the popup should open relative to the iconAnchor
		}),
		L.icon({
			iconUrl: '../resources/images/search-address-pin.svg',
			iconSize: [32, 32], // size of the icon
			iconAnchor: [16, 31], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -32] // point from which the popup should open relative to the iconAnchor
		}),
		L.icon({
			iconUrl: '../resources/images/moving2.svg',
			iconSize: [32, 32], // size of the icon
			iconAnchor: [16, 31], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -32] // point from which the popup should open relative to the iconAnchor
		}),
		L.icon({
			iconUrl: '../resources/images/moving.svg',
			iconSize: [32, 32], // size of the icon
			iconAnchor: [16, 31], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -32] // point from which the popup should open relative to the iconAnchor
		}),
		L.icon({
			iconUrl: '../resources/images/offline.svg',
			iconSize: [32, 32], // size of the icon
			iconAnchor: [16, 31], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -32] // point from which the popup should open relative to the iconAnchor
		}),
		L.icon({
			iconUrl: '../resources/images/ignition-off.svg',
			iconSize: [32, 32], // size of the icon
			iconAnchor: [16, 31], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -32] // point from which the popup should open relative to the iconAnchor
		}),
		L.icon({
			iconUrl: '../resources/images/ignition-on.svg',
			iconSize: [32, 32], // size of the icon
			iconAnchor: [16, 31], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -32] // point from which the popup should open relative to the iconAnchor
		}),
		L.icon({
			iconUrl: '../resources/images/job-pin.svg',
			iconSize: [32, 32], // size of the icon
			iconAnchor: [16, 31], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -32] // point from which the popup should open relative to the iconAnchor
		}),
		L.icon({
			iconUrl: '../resources/images/job-active.svg',
			iconSize: [32, 32], // size of the icon
			iconAnchor: [16, 31], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -32] // point from which the popup should open relative to the iconAnchor
		}),
		L.icon({
			iconUrl: '../resources/images/job-start.svg',
			iconSize: [32, 32], // size of the icon
			iconAnchor: [16, 31], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -32] // point from which the popup should open relative to the iconAnchor
		}),
		L.icon({
			iconUrl: '../resources/images/job-start-active.svg',
			iconSize: [32, 32], // size of the icon
			iconAnchor: [16, 31], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -32] // point from which the popup should open relative to the iconAnchor
		}),
		L.icon({
			iconUrl: '../resources/images/poi-marker/air_fixwing.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		}),

		L.icon({
			iconUrl: '../resources/images/poi-marker/airport_terminal.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		}),

		L.icon({
			iconUrl: '../resources/images/poi-marker/apartment.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		}),

		L.icon({
			iconUrl: '../resources/images/poi-marker/cctv.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		}),

		L.icon({
			iconUrl: '../resources/images/poi-marker/condominium.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		}),

		L.icon({
			iconUrl: '../resources/images/poi-marker/constructioncrane.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		}),

		L.icon({
			iconUrl: '../resources/images/poi-marker/cruiseship.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		}),

		L.icon({
			iconUrl: '../resources/images/poi-marker/factory.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		}),
		L.icon({
			iconUrl: '../resources/images/poi-marker/firstaid.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		}),

		L.icon({
			iconUrl: '../resources/images/poi-marker/glazer.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		}),

		L.icon({
			iconUrl: '../resources/images/poi-marker/home.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		}),

		L.icon({
			iconUrl: '../resources/images/poi-marker/house.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		}),

		L.icon({
			iconUrl: '../resources/images/poi-marker/mastcrane1.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		}),

		L.icon({
			iconUrl: '../resources/images/poi-marker/office-building.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		}),

		L.icon({
			iconUrl: '../resources/images/poi-marker/oilpumpjack.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		}),

		L.icon({
			iconUrl: '../resources/images/poi-marker/photo.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		}),

		L.icon({
			iconUrl: '../resources/images/poi-marker/repair.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		}),

		L.icon({
			iconUrl: '../resources/images/poi-marker/satellite-dish.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		}),

		L.icon({
			iconUrl: '../resources/images/poi-marker/splice.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		}),

		L.icon({
			iconUrl: '../resources/images/poi-marker/star.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		}),

		L.icon({
			iconUrl: '../resources/images/poi-marker/townhouse.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		}),

		L.icon({
			iconUrl: '../resources/images/poi-marker/villa.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		}),

		L.icon({
			iconUrl: '../resources/images/poi-marker/wifi.svg',
			iconSize: [32, 32],
			iconAnchor: [16, 31],
			popupAnchor: [0, -32]
		})

	],
  UpgradeToLive: [
    {
      url: 'https://activation.reconogps.com/upgrade-to-live.php',
      code: 98
    },
    {
      url: 'https://activation.wardengps.com/app/upgrade-to-live.php',
      code: 29
    },
    {
      url: 'https://activation.gps-secure.co/upgrade-to-live.php',
      code: 42
    },
    {
      url: 'https://activation.western.gps-secure.co/app/upgrade-to-live.php',
      code: 30
    },
    {
      url: 'https://activation.cobra.gps-secure.co/app/upgrade-to-live.php',
      code: 57
    },
    {
      url: 'https://activation.autoprotect.live/app/upgrade-to-live.php',
      code: 5
    },
    {
      url: 'https://activation.boatwatch.co/app/upgrade-to-live.php',
      code: 22
    },
    {
      url: 'https://activation.al3rtgps.co/app/upgrade-to-live.php',
      code: 1
    },
    {
      url: 'https://activation.blackboxgps.co/upgrade-to-live.php',
      code: 33
    },
    {
      url: 'https://activation.ispygps.co/upgrade-to-live.php',
      code: 15
    },
    {
      url: 'https://activation.iss-secure.co/app/upgrade-to-live.php',
      code: 35
    },
    {
      url: 'https://activationgeelinx.cartrack.co/upgrade-to-live.php',
      code: 13
    },
    {
      url: 'https://activationisstrack.cartrack.co/upgrade-to-live.php',
      code: 14
    },
    {
      url: 'https://activation.nutechgps.com/upgrade-to-live.php',
      code: 18
    },
    {
      url: 'https://activation.on-trackgps.co/upgrade-to-live.php',
      code: 37
    },
    {
      url: 'https://activation.pillalogps.com/app/upgrade-to-live.php',
      code: 19
    },
    {
      url: 'https://activation.pvstrack.com/app/upgrade-to-live.php',
      code: 20
    },
    {
      url: 'https://activation.quiktrak.au/upgrade-to-live.php',
      code: 31
    },
    {
      url: 'https://activation.secure-track.com/app/upgrade-to-live.php',
      code: 36
    },
    {
      url: 'https://activation.selftrack.co/app/upgrade-to-live.php',
      code: 23
    },
    {
      url: 'https://activation.smartostrichfleet.com/upgrade-to-live.php',
      code: 24
    },
    {
      url: 'https://activation.tekamogps.co/upgrade-to-live.php',
      code: 26
    },
    {
      url: 'https://activation.ufindgps.co/upgrade-to-live.php',
      code: 28
    },
    {
      url: 'https://activation.vizngps.co/app/upgrade-to-live.php',
      code: 34
    },
    {
      url: 'https://activation.witigps.com/upgrade-to-live.php',
      code: 16
    },
    {
      url: 'https://activationais.cartrack.co/upgrade-to-live.php',
      code: 4
    },
    {
      url: 'https://activationcbhgroup.cartrack.co/app/upgrade-to-live.php',
      code: 9
    },
    {
      url: 'https://activationcyclops.cartrack.co/upgrade-to-live.php',
      code: 11
    },
    {
      url: 'https://activationfridgewatch.cartrack.co/upgrade-to-live.php',
      code: 12
    },
  ],
  PositionTypes: {
    "NONE": 0,
    "GPS": 1,
    "LBS": 2,
    "GPSLBS": 3,
    "IRIDIUM": 4,
    "COMPASS": 8,
    "GLONASS": 16,
    "WiFi": 32
  },
  DeviceStatus: {
    "Disable": 0,
    "Normal": 1,
    "Overdue": -1
  },
  PositionAlerts: {
    "None": 0,
    "Custom": 1,
    "SOS": 2,
    "ElectricCutoff": 4,
    "InGeoFance": 8,
    "OutGeoFance": 16,
    "HighSpeed": 32,
    "LowSpeed": 64,
    "Theft": 128,
    "Vibrate": 256,
    "LowPower": 512,
    "Moving": 1024,
    "Fire": 2048,
    "MedicalHelp": 4096,
    "Defence": 8192,
    "Destroy": 16384,
    "ACCON": 32768,
    "ACCOFF": 65536,
    "INPUT1": 131072,
    "INPUT2": 262144,
    "INPUT1_LOW": 524288,
    "INPUT2_LOW": 1048576,

    "INPUT3": 134217728,
    "INPUT3_LOW": 268435456,
    "INPUT4": 536870912,
    "INPUT4_LOW": 1073741824,

    "HardBrake": 2097152,
    "LowTemp": 4194304,
    "HighTemp": 8388608,
    "FatigueDriving": 16777216,
    "Accelerate": 33554432,
    "Offline": 67108864,
    "INPUT3": 134217728,
    "INPUT3_OFF": 268435456,
    "INPUT4": 536870912,
    "INPUT4_OFF": 1073741824,
  },
  PositionStatus: {
    "NONE": 0,
    "ACC": 1,
    "Static": 2,
    "Power": 4,
    "Charging": 8,
    "BeProtected": 16,
    "ACC2": 32,
    "Relay": 64,
    "ForceSave": 2097152,
    "input1": 8192,
    "input2": 16384,
  },
  EventClasses: {
    "PROTOCOL_DEFINED": 0,
    "ALERT": 1,
    "ACC": 2,
    "STATIC": 4,
    "COMMAND": 8,
    "POI": 16,
    "ACC2": 32,
    "GEOLOCK": 64,
    "ACC3": 128,
    "SERVICEINTERVAL": 256,
    "NEW_SERVICEINTERVAL": 512,
    "POI_STATION": 1024
  },
  EventCommandTypes: {
    "NONE": 0,
    "REQUEST": 1,
    "RESPONSE": 2
  },
  ProductFeatures: {
    None: 0,
    LatLng: 1,
    Alt: 2,
    Direct: 4,
    Speed: 8,
    Mileage: 16,
    GsmSignal: 32,
    GpsSignal: 64,
    Acc: 128,
    Static: 256,
    Voltage: 512,
    Battery: 1024,
    FuelSensor: 2048,
    TempSensor: 4096,
    OBD: 8192,
    RFIDCard: 16384,
    Holder: 32768,
    DrivingTime: 65536,
    //oldAcc2: 131072,
    Acc2: 16777216,
    Heartrate: 262144,
    Charging: 524288,
    BrakePedal: 1048576,
    Camera: 2097152,
    HarshBracking: 4194304,
    HarshAcceleration: 8388608,
    //oldInput1: 16777216,
    Input2: 16777216,
    Input1: 131072,
    Input3: 33554432,
    Input4: 67108864,
    Output1: 134217728,
    Output2: 268435456,
  },
  ProductInputFeatures: {
    //oldInput1: 16777216,
    //oldInput2: 131072,
    Input1: 131072,
    Input2: 16777216,

    Input3: 33554432,
    Input4: 67108864,
    Output1: 134217728,
    Output2: 268435456,
  },
  InputActiveState: {
    Input1: 512,
    Input2: 128,
    Input3: 1024,
    Input4: 2048,
    Output1: 4096,
    Output2: 8192,

    /*Input3: 33554432,
    Input4: 67108864,
    Output1: 134217728,
    Output2: 268435456,*/
  },
  StatusNewEnum: {
    "Geolock": 1,
    "Immobilise": 2,
    "LockDoor": 4,
  },
  CustomerTypes: {
    Agent: 2,
    Enterprise: 4,
    Personal: 5,
    Dealer: 6,
    Master: 7,
    ProtectEnterprise: 8,
  },
  UserRoleTypes: {
    Admin: 1,
    Controller: 2,
    Installer: 4,
    Dirver: 5,
    User: 6,
    Standard: 7,
    View: 9,
    ViewOnly: 10,
    FullAccess: 11
  },
  // DaysOfWeek: [
  //   {
  //     val: 0,
  //     name: LANGUAGE.COM_MSG38,
  //     nameSmall: LANGUAGE.COM_MSG45,
  //   },
  //   {
  //     val: 1,
  //     name: LANGUAGE.COM_MSG39,
  //     nameSmall: LANGUAGE.COM_MSG46,
  //   },
  //   {
  //     val: 2,
  //     name: LANGUAGE.COM_MSG40,
  //     nameSmall: LANGUAGE.COM_MSG47,
  //   },
  //   {
  //     val: 3,
  //     name: LANGUAGE.COM_MSG41,
  //     nameSmall: LANGUAGE.COM_MSG48,
  //   },
  //   {
  //     val: 4,
  //     name: LANGUAGE.COM_MSG42,
  //     nameSmall: LANGUAGE.COM_MSG49,
  //   },
  //   {
  //     val: 5,
  //     name: LANGUAGE.COM_MSG43,
  //     nameSmall: LANGUAGE.COM_MSG50,
  //   },
  //   {
  //     val: 6,
  //     name: LANGUAGE.COM_MSG44,
  //     nameSmall: LANGUAGE.COM_MSG51,
  //   },
  // ],

  Permissions2Enum: {
    MonthlyAccountReport: 64,
  },
  

  Common: class {
    constructor(arg) {
      this.initDeviceInfo(arg);
      this.posInfo = {};
    }
    initDeviceInfo(arg) {
      this.Id = arg.Id;
      this.IMEI = arg.IMEI;
      this.Name = arg.Name;
      this.TagName = arg.TagName;
      this.Icon = arg.Icon;
      this.Unit = arg.Unit;
      this.InitMileage = arg.InitMileage;
      this.InitAcconHours = arg.InitAcconHours;
      this.State = arg.State;
      this.ActivateDate = arg.ActivateDate;
      this.PayPlanName = arg.PayPlanName;
      this.PRDTName = arg.PRDTName;
      this.PRDTFeatures = arg.PRDTFeatures;
      this.PRDTAlerts = arg.PRDTAlerts;
      this.Describe1 = arg.Describe1;
      this.Describe2 = arg.Describe2;
      this.Describe3 = arg.Describe3;
      this.Describe4 = arg.Describe4;
      this.Describe5 = arg.Describe5;
      this.Describe7 = arg.Describe7;
      this._FIELD_FLOAT1 = arg._FIELD_FLOAT1;
      this._FIELD_FLOAT2 = arg._FIELD_FLOAT2;
      this._FIELD_FLOAT7 = arg._FIELD_FLOAT7;
      this.AlarmOptions = arg.AlarmOptions;
      this.StatusNew = arg.StatusNew;
      this._FIELD_FLOAT8 = arg._FIELD_FLOAT8;
      this.IMSI = arg.IMSI;
      this._FIELD_INT2 = arg._FIELD_INT2;
      this.GroupCode = arg.GroupCode;
      this.SolutionType = arg.SolutionType;
      this.Registration = arg.Registration;
      this.StockNumber = arg.StockNumber;
      this.MaxSpeed = arg.MaxSpeed;
      this.MaxSpeedAlertMode = arg.MaxSpeedAlertMode;
      this.StorageTime = arg.StorageTime;
      this.DaysInInventory = arg.DaysInInventory;
      this.ActivationTime = arg.ActivationTime;
      this.BusinessExpense = arg.BusinessExpense;
      this.FuelEconomy = arg.FuelEconomy;
      this.EngineCapacity = arg.EngineCapacity;
      this.OffroadTaxCredit = arg.OffroadTaxCredit;
      this.AssetType = arg.AssetType;
      this.DriverCode = arg.DriverCode;
      this.RoadSpeed = arg.RoadSpeed;
      this.LBSWIFI = arg.LBSWIFI;
      this.STATICDRIFT = arg.STATICDRIFT;
      this.Input1Name = arg.Input1Name;
      this.Input2Name = arg.Input2Name;
      this.Input3Name = arg.Input3Name;
      this.Input4Name = arg.Input4Name;
      this.Output1Name = arg.Output1Name;
      this.Output2Name = arg.Output2Name;
      this.isShared = arg.isShared;
      this.SuspendDate = arg.SuspendDate;
      this.SubscriptionId = arg.SubscriptionId;
      this.LicenceDisk = arg.LicenceDisk;
      this.DiskExpiryDate = arg.DiskExpiryDate;
      this.iButtonFlag = arg.iButtonFlag;
      this.ActualAlarmNames = arg.ActualAlarmNames
      this.IsLocalRenewal = arg.IsLocalRenewal;   
    }
    initDeviceInfoEx () { }
    initPosInfo (ary) {
      var posInfo = {};
  
      posInfo.assetID = ary[0];
      posInfo.imei = ary[1];
      posInfo.protocolClass = ary[2];
      posInfo.positionType = ary[3];
      posInfo.dataType = ary[4];
      if (ary[5] !== null) {
  
        posInfo.positionTime = moment(ary[5].split('.')[0]).add(CustomerInfo.TimeZone, 'hours');
      }
      else {
        posInfo.positionTime = null;
      }
      if (ary[6] !== null) {
        posInfo.sysTime = moment(ary[6].split('.')[0]).add(CustomerInfo.TimeZone, 'hours');
      }
      else {
        posInfo.sysTime = null;
      }
      if (ary[7] !== null) {
        posInfo.staticTime = moment(ary[7]).add(CustomerInfo.TimeZone, 'hours');
      }
      else {
        posInfo.staticTime = null;
      }
      posInfo.isRealTime = ary[8];
      posInfo.isLocated = ary[9];
      posInfo.satelliteSignal = ary[10];
      posInfo.gsmSignal = ary[11];
      posInfo.lat = !ary[12].toString().includes('22.675') ? ary[12] : ary[1] == '0863014530815966' ? '-33.8078' : ary[1] == '0863014530815962' ? '-26.480934' : '-26.209168';
      posInfo.lng = !ary[13].toString().includes('113.972') ? ary[13] : ary[1] == '0863014530815966' ? '25.621116' : ary[1] == '0863014530815962' ? '29.961116' : '28.104366';
      //posInfo.lat = ary[12]; 
      //posInfo.lng = ary[13];
      posInfo.alt = ary[14];
      posInfo.direct = ary[15];
      posInfo.speed = ary[16];
      posInfo.mileage = ary[17];
      posInfo.launchHours = ary[18];
      posInfo.alerts = ary[19];
      posInfo.status = ary[20];
      posInfo.originalAlerts = ary[21];
      posInfo.originalStatus = ary[22];
      this.initPosInfoEx(ary, posInfo);
      //fconsole.log('ary',ary,posInfo.status, ary[20])
      this.posInfo = posInfo;
  
      if (ary[13].toString().includes('113.972')) {
        //console.log(ary[1])
      }
      return posInfo;
    }
    initPosInfoEx () { }
    initHisPosInfo (ary) {
      var posInfo = {};
      posInfo.assetID = ary[0];
      posInfo.positionType = ary[1];
      posInfo.dataType = ary[2];
      if (ary[3] !== null) {
        posInfo.positionTime = moment(ary[3].split('.')[0]).add(CustomerInfo.TimeZone, 'hours');
      }
      else {
        posInfo.positionTime = null;
      }
      if (ary[4] !== null) {
        posInfo.sysTime = moment(ary[4]).add(CustomerInfo.TimeZone, 'hours');
      }
      else {
        posInfo.sysTime = null;
      }
      if (ary[5] !== null) {
        posInfo.staticTime = moment(ary[5]).add(CustomerInfo.TimeZone, 'hours');
      }
      else {
        posInfo.staticTime = null;
      }
      posInfo.isRealTime = ary[6];
      posInfo.isLocated = ary[7];
      posInfo.satelliteSignal = ary[8];
      posInfo.gsmSignal = ary[9];
      posInfo.lat = ary[10];
      posInfo.lng = ary[11];
      posInfo.alt = ary[12];
      posInfo.direct = ary[13];
      posInfo.speed = ary[14];
      posInfo.mileage = ary[15];
      posInfo.launchHours = ary[16];
      posInfo.alerts = ary[17];
      posInfo.status = ary[18];
      posInfo.originalAlerts = ary[19];
      posInfo.originalStatus = ary[20];
      this.initHisPosInfoEx(ary, posInfo);
      return posInfo;
    }
    initHisPosInfoEx () { }
    initEventInfo (ary) {
      var event = {};
      event.assetID = ary[0];
      event.eventClass = ary[1];
      event.eventType = ary[2];
      event.state = ary[3];
      event.otherCode = ary[4];
      event.otherCode2 = ary[5];
      event.contactCode = ary[6];
      event.beginTime = moment(ary[7]).add(CustomerInfo.TimeZone, 'hours');
      event.endTime = moment(ary[8]).add(CustomerInfo.TimeZone, 'hours');
      event.positionType = ary[9];
      event.lat = ary[10];
      event.lng = ary[11];
      event.alt = ary[12];
      event.alerts = ary[13];
      event.status = ary[14];
      this.initEventInfoEx(ary, event);
      return event;
    }
    initEventInfoEx() { }
    haveFeature(feature) {
      return (Protocol.ProductFeatures[feature] & this.PRDTFeatures) > 0;
    }
    getStaticTimeSpan () {
      var ret = "";
      if (this.posInfo.speed === 0 && this.posInfo.positionTime !== null && this.posInfo.staticTime !== null) {
        ret = TimeSpan(this.posInfo.positionTime.diff(this.posInfo.staticTime, 'milliseconds')).format("^hh:mm:ss");
      }
      return ret;
    }
  },
  ClassManager: {
    array: {},
    add(name, clas) {
      Protocol.ClassManager.array[name] = clas;
    },
    get(name, arg) {
      return Protocol.ClassManager.array[name]
        ? new Protocol.ClassManager.array[name](arg)
        : new Protocol.Common(arg);
    },
  },
}
 
 

 

 
 




export function getAssetStateInfo(asset, additionalOptions = false) {
  /*
      state-0  -- gray
      state-1  -- green
      state-2  -- yellow
      state-3  -- red
  */
  //var staticIdle = asset.getStaticTimeSpan();
  var ret = {};
  if (asset) {

    var dateTimeSecond = 24 * 600 * 60 * 1000;
    //console.log(asset.posInfo.positionTime);
    if (asset.posInfo.positionTime !== null) {
      try {
        dateTimeSecond = Math.abs(moment(moment(asset.posInfo.positionTime.toDate()).add(CustomerInfo.TimeZone, 'hours').toDate()).diff(moment(moment(moment().toDate()).add((moment().utcOffset() / 60), 'hours').toDate()), 'milliseconds'));
      } catch (error) {
        console.log(error);
      }

    }

    if (asset.posInfo.positionTime !== null) {
      try {
        if (asset.posInfo.lat === 0 || asset.posInfo.lng === 0 || (asset.posInfo.positionTime !== null && Math.abs(moment(moment(asset.posInfo.positionTime.toDate()).add(CustomerInfo.TimeZone).toDate(), 'hours').diff(moment(moment(moment().toDate()).add((moment().utcOffset() / 60)).toDate()), 'milliseconds'), 'hours') > 40 * 60 * 1000)) {
          asset.posInfo.isRealTime = "False";
          asset.posInfo.isLocated = "False";
          asset.posInfo.speed = 0;
          asset.posInfo.status = 0;
        }
      } catch (error) {
        console.log(error);
      }
    }

    ret.geolock = false;
    if (asset.posInfo.status & Protocol.PositionStatus.BeProtected > 0) {
      ret.geolock = true;
    }
    ret.immobilisation = false;
    if (asset.posInfo.status & Protocol.PositionStatus.Relay > 0) {
      ret.immobilisation = true;
    }

    ret.stats = true;
    if (asset.posInfo.positionTime === null) {
      ret.stats = false;

    } else {
      ret.istDriverRatingSupported = false;
      if (asset.haveFeature("HarshBracking") && asset.haveFeature("HarshAcceleration")) {
        ret.istDriverRatingSupported = true;
      }

      if (asset.haveFeature("Speed")) {
        if (asset.haveFeature("Acc") && (Protocol.PositionStatus.ACC & asset.posInfo.status) === 0) {
          asset.posInfo.speed = 0;
        }
        ret.speed = {};
        if (asset.posInfo.speed < 0) {
          asset.posInfo.speed = 0;
        }
        ret.speed.value = Protocol.Helper.getSpeedValue(asset.Unit, asset.posInfo.speed) + ' ' + Protocol.Helper.getSpeedUnit(asset.Unit);
      }
      if (asset.haveFeature("TempSensor")) {
        ret.temperature = {};
        if (typeof asset.posInfo.alt == "undefined") {
          ret.temperature.value = LANGUAGE.COM_MSG11;
        } else {
          ret.temperature.value = asset.posInfo.alt + '&nbsp;°C';
        }
      }
      if (asset.posInfo.temp1) {
        ret.temp1 = {};
        ret.temp1.value = asset.posInfo.temp1 + '&nbsp;°C';
      }
      if (asset.posInfo.temp2) {
        ret.temp2 = {};
        ret.temp2.value = asset.posInfo.temp2 + '&nbsp;°C';
      }
      if (asset.posInfo.temp3) {
        ret.temp3 = {};
        ret.temp3.value = asset.posInfo.temp3 + '&nbsp;°C';
      }
      if (asset.posInfo.temp4) {
        ret.temp4 = {};
        ret.temp4.value = asset.posInfo.temp4 + '&nbsp;°C';
      }
      if (asset.posInfo.temp5) {
        ret.temp5 = {};
        ret.temp5.value = asset.posInfo.temp5 + '&nbsp;°C';
      }
      if (asset.posInfo.temp6) {
        ret.temp6 = {};
        ret.temp6.value = asset.posInfo.temp6 + '&nbsp;°C';
      }
      if (asset.posInfo.temp7) {
        ret.temp7 = {};
        ret.temp7.value = asset.posInfo.temp7 + '&nbsp;°C';
      }
      if (asset.posInfo.temp8) {
        ret.temp8 = {};
        ret.temp8.value = asset.posInfo.temp8 + '&nbsp;°C';
      }

      if (asset.haveFeature("FuelSensor")) {
        ret.fuel = {};
        if (typeof asset.posInfo.fuel == "undefined" || asset.posInfo.fuel == 0 && asset._FIELD_FLOAT2 == 0 && asset._FIELD_FLOAT1 == 0) {
          ret.fuel.value = LANGUAGE.COM_MSG11;
        } else {
          ret.fuel.value = parseInt(((parseFloat(asset.posInfo.fuel) - asset._FIELD_FLOAT2) / (asset._FIELD_FLOAT1 - asset._FIELD_FLOAT2)) * 100) + '&nbsp;%';
        }
      }
      if (asset.haveFeature("Voltage")) {
        ret.voltage = {};
        ret.voltage.value = LANGUAGE.COM_MSG11;

        if (asset.posInfo.Voltage) {
          ret.voltage.value = Math.round(asset.posInfo.Voltage * 10) / 10 + '&nbsp;V';//LANGUAGE.COM_MSG11;
        } else {
          //ret.voltage.value = Math.round(asset.posInfo.alt*10)/10;
          //additionalOptions && additionalOptions.onlyNumber ? '' : ret.voltage.value += '&nbsp;V';
          ret.voltage.value = (asset.posInfo.alt > 50 || !asset.posInfo.alt ? LANGUAGE.COM_MSG031 : "" + Math.round(asset.posInfo.alt * 10) / 10 + '&nbsp;V');

        }
      }
      if (asset.haveFeature("Mileage")) {
        ret.mileage = {};
        if (additionalOptions && additionalOptions.inKilometers) {
          ret.mileage.value = (Protocol.Helper.getMileageValue('KPH', asset.posInfo.mileage) + parseInt(asset.InitMileage) + parseInt(asset._FIELD_FLOAT7));
          additionalOptions && additionalOptions.onlyNumber ? '' : ret.mileage.value += '&nbsp;' + Protocol.Helper.getMileageUnit(asset.Unit);
        } else {
          ret.mileage.value = (Protocol.Helper.getMileageValue(asset.Unit, asset.posInfo.mileage) + parseInt(asset.InitMileage) + parseInt(asset._FIELD_FLOAT7)) + '&nbsp;' + Protocol.Helper.getMileageUnit(asset.Unit);
        }


        ret.engineHours = {};
        if (asset.posInfo.Engine) {
          asset.posInfo.launchHours = asset.posInfo.Engine;
        }
        ret.engineHours.value = TimeSpan(parseInt(asset.posInfo.launchHours) * 1000 + parseInt(asset.InitAcconHours) * 60 * 60 * 1000 + parseInt(asset._FIELD_FLOAT8) * 1000).format("^hh:mm:ss");
        //console.log(asset);

      }
      if (asset.haveFeature("Acc")) {
        ret.acc = {};
        //if((Protocol.PositionStatus.ACC & asset.posInfo.status) > 0 && asset.posInfo.isLocated=="True"){
        //if((Protocol.PositionStatus.ACC & this.posInfo.status) > 0)
        if ((Protocol.PositionStatus.ACC & asset.posInfo.status) > 0) {
          ret.acc.value = 'ON';
        } else {
          ret.acc.value = 'OFF';
        }
      }
      if (asset.haveFeature("Acc2")) {
        ret.acc2 = {};
        if ((Protocol.PositionStatus.ACC2 & asset.posInfo.status) > 0) {
          ret.acc2.value = 'ON';
        } else {
          ret.acc2.value = 'OFF';
        }
      }
      if (asset.haveFeature("Battery")) {
        ret.battery = {};
        if (asset.posInfo.Battery) {
          ret.battery.value = parseInt(asset.posInfo.Battery) + '&nbsp;%';
        } else {
          ret.battery.value = LANGUAGE.COM_MSG11; // no data
        }
      }
      if (asset.haveFeature("Alt")) {
        ret.altitude = {};
        ret.altitude.value = asset.posInfo.alt + '&nbsp;ft';
      }
      /*if(asset.haveFeature("RFIDCard")){
          ret.driver = {};
          if(asset.posInfo.rfid !== null && asset.posInfo.rfid !== ""){
              var hasFound = false;
              for(var i= 0; i< ContactList.length; i++){
                  if(asset.posInfo.rfid == ContactList[i].Number){
                      hasFound = true;
                      ret.driver.value = ContactList[i].FirstName + " " + ContactList[i].SurName;
                      break;
                  }
              }
              if(!hasFound){
                  ret.driver.value = asset.posInfo.rfid;
              }
          }else{
              ret.driver.value = LANGUAGE.COM_MSG11;
          }
      }else if(asset.haveFeature("Driver")){
          ret.driver = {};
          var name = '';
          if(asset.contactCode !== null && asset.contactCode !== ""){
              for(var j = 0; j< ContactList.length; j++){
                  if(asset.contactCode == ContactList[j].Code){
                      name += ContactList[j].FirstName + " " + ContactList[j].SurName;
                      break;
                  }
              }
          }
          ret.driver.value = name;
      }   */
      ret.boatStates = {
        bilgePump: {
          state: 'state-0',
          value: LANGUAGE.COM_MSG93
        },
        shorePower: {
          state: 'state-0',
          value: LANGUAGE.COM_MSG93
        }
      }

      if ((asset.originalStatus & Protocol.PositionStatus.input1) > 0) {
        ret.boatStates.bilgePump.state = 'state-1'
        ret.boatStates.bilgePump.value = LANGUAGE.COM_MSG94
      }
      if ((asset.originalStatus & Protocol.PositionStatus.input2) > 0) {
        ret.boatStates.shorePower.state = 'state-1'
        ret.boatStates.shorePower.value = LANGUAGE.COM_MSG94
      }

      ret.installation = {
        input1name: {
          state: 'state-1',
          value: LANGUAGE.COM_MSG93
        },
        input2name: {
          state: 'state-1',
          value: LANGUAGE.COM_MSG93
        },
        input3name: {
          state: 'state-1',
          value: LANGUAGE.COM_MSG93
        },
        input4name: {
          state: 'state-1',
          value: LANGUAGE.COM_MSG93
        },
        output1name: {
          state: 'state-5',
          value: LANGUAGE.COM_MSG93
        },
        output2name: {
          state: 'state-5',
          value: LANGUAGE.COM_MSG93
        },
      }

      if ((asset.posInfo.status & Protocol.InputActiveState.Input1) > 0) {
        ret.installation.input1name.state = 'state-3'
        ret.installation.input1name.value = LANGUAGE.COM_MSG94
      }
      if ((asset.posInfo.status & Protocol.InputActiveState.Input2) > 0) {
        ret.installation.input2name.state = 'state-3'
        ret.installation.input2name.value = LANGUAGE.COM_MSG94
      }
      if ((asset.posInfo.status & Protocol.InputActiveState.Input3) > 0) {
        ret.installation.input3name.state = 'state-3'
        ret.installation.input3name.value = LANGUAGE.COM_MSG94
      }
      if ((asset.posInfo.status & Protocol.InputActiveState.Input4) > 0) {
        ret.installation.input4name.state = 'state-3'
        ret.installation.input4name.value = LANGUAGE.COM_MSG94
      }
      if ((asset.posInfo.status & Protocol.InputActiveState.Output1) > 0) {
        ret.installation.output1name.state = 'state-4'
        ret.installation.output1name.value = LANGUAGE.COM_MSG94
      }
      if ((asset.posInfo.status & Protocol.InputActiveState.Output2) > 0) {
        ret.installation.output2name.state = 'state-4'
        ret.installation.output2name.value = LANGUAGE.COM_MSG94
      }
      //console.log('e3', asset.posInfo.status, Protocol.InputActiveState)

      ret.GPS = {};
      ret.GPS.state = 'state-1';
      ret.GPS.value = randomIntFromInterval(71, 95) + '%';
      ret.GSM = {};
      ret.GSM.state = 'state-1';
      ret.GSM.value = randomIntFromInterval(71, 95) + '%';
      if (asset.posInfo.lat === 0 || asset.posInfo.lng === 0 || dateTimeSecond > 40 * 60 * 1000) {
        ret.GPS.state = 'state-0';
        ret.GPS.value = '0%';
      }
      if (dateTimeSecond > 5 * 60 * 60 * 1000) {
        ret.GSM.state = 'state-0';
        ret.GSM.value = '0%';
      }
      ret.status = {};
      if (parseInt(asset.posInfo.speed) > 0) {
        ret.status.value = LANGUAGE.HOME_MSG014;
        ret.status.state = 'state-1';
        ret.status.event = LANGUAGE.HOME_MSG017;
        ret.status.eventTime = asset.posInfo.positionTime.format(window.COM_TIMEFORMAT);
        ret.GSM.state = 'state-1';
        ret.GSM.value = randomIntFromInterval(71, 95) + '%';
      }
      else if (parseInt(asset.posInfo.speed) === 0) {
        if (asset.haveFeature("Acc") && (Protocol.PositionStatus.ACC & asset.posInfo.status) > 0) {
          ret.status.value = LANGUAGE.HOME_MSG016;
          ret.status.state = 'state-2';
          ret.status.eventTime = asset.posInfo.positionTime.format(window.COM_TIMEFORMAT);
          ret.status.event = LANGUAGE.HOME_MSG018;
          ret.GSM.state = 'state-1';
          ret.GSM.value = randomIntFromInterval(71, 95) + '%';
        } else {
          if (asset.posInfo.staticTime) {
            //ret.status.value = LANGUAGE.ASSET_STATUS_MSG04+' <span class="stopped_time">('+asset.posInfo.staticTime.format(window.COM_TIMEFORMAT)+')</span>';

            ret.stopped = {};
            ret.stopped.time = asset.posInfo.staticTime.format(window.COM_TIMEFORMAT);
            var dateDifference = Protocol.Helper.getDifferenceBTtwoDates(asset.posInfo.staticTime, moment());
            ret.stopped.duration = moment.duration(dateDifference, "milliseconds").format('d[d] h[h] m[m]');

          }
          ret.status.value = LANGUAGE.HOME_MSG015;
          ret.status.state = 'state-0';
          ret.status.eventTime = asset.posInfo.positionTime.format(window.COM_TIMEFORMAT);
          ret.status.event = LANGUAGE.HOME_MSG018;
          ret.GSM.state = 'state-1';
          ret.GSM.value = randomIntFromInterval(71, 95) + '%';
        }

      }

      if (dateTimeSecond > 72 * 60 * 60 * 1000) {
        ret.GSM.state = 'state-3';
        ret.GSM.value = randomIntFromInterval(5, 10) + '%';
      }
      else if (dateTimeSecond > 24 * 60 * 60 * 1000) {
        ret.GSM.state = 'state-2';
        ret.GSM.value = randomIntFromInterval(25, 70) + '%';
      }
      else if (dateTimeSecond > 12 * 60 * 60 * 1000) {
        ret.GSM.state = 'state-0';
        ret.GSM.value = '0%';
      } else {
        ret.GSM.state = 'state-1';
        ret.GSM.value = randomIntFromInterval(71, 95) + '%';
      }

      if (dateTimeSecond > 48 * 60 * 60 * 1000) {
        ret.GPS.state = 'state-0';
        ret.GPS.value = '0%';
      }
      else if (asset.haveFeature("Acc") && (Protocol.PositionStatus.ACC & asset.posInfo.status) === 0 && asset.posInfo.speed === 0) {
        ret.GPS.state = 'state-1';
        ret.GPS.value = randomIntFromInterval(71, 95) + '%';
      }
      else if (asset.posInfo.speed > 0) {
        ret.GPS.state = 'state-1';
        ret.GPS.value = randomIntFromInterval(71, 95) + '%';
      } else if (asset.posInfo.speed === 0) {
        ret.GPS.state = 'state-1';
        ret.GPS.value = randomIntFromInterval(71, 95) + '%';
      }

      ret.geolock = {
        value: false,
        state: 'state-0',
      };
      ret.immob = {
        value: false,
        state: 'state-0',
      };
      ret.lockdoor = {
        value: false,
        state: 'state-0',
      };
      if (asset.StatusNew) {
        var geolockImmobSate = Protocol.Helper.getGeoImmobState(asset.StatusNew);
        if (geolockImmobSate.Geolock) {
          ret.geolock.value = geolockImmobSate.Geolock;
          ret.geolock.state = 'state-1';
        }
        if (geolockImmobSate.Immobilise) {
          ret.immob.value = geolockImmobSate.Immobilise;
          ret.immob.state = 'state-3';
        }
        if (geolockImmobSate.LockDoor) {
          ret.lockdoor.value = geolockImmobSate.LockDoor;
          ret.lockdoor.state = 'state-3';
        }
      }

    }
  }


  return ret;
}


export const RechargePlanPrices = {
  100: 10,
  500: 45,
  1000: 80
}

export function toGETFormat(source) {

}

export function getInputsTypes() {
  return [
    { code: "NONE", name: 'None', icon: '', },
    { code: "ACC2", name: 'ACC2', icon: 'input-car-alarm', },
    { code: "ALARM", name: 'Alarm', icon: 'input-car-alarm3', },
    { code: "BILGE", name: 'Bilge', icon: 'input-bilge-alarm', },
    { code: "DOOR", name: 'Door', icon: 'input-door-alarm', },
    { code: "PTO", name: 'PTO', icon: 'input-pto-alarm', },
    { code: "SHORE", name: 'Shore', icon: 'input-shore-power', },
    { code: "PLOW", name: 'SnowPlow', icon: 'input-snow-plow', },
    { code: "TILT", name: 'Tilt', icon: 'input-tilt-alarm', },
  ]
}


export function getPlaybackFilterHistoryList() {
  const { t } = i18n.global
 
  return [
    {
      Name: t('REPORT_ALERT_LIST_MSG17'),  //Ignition On
      Value: '1',
      IconBg: 'bg-color-green',
      Icon: 'icon-ignition',
      IconHTML: `<div class='user-icon text-align-center text-color-white bg-color-green display-flex align-items-center justify-content-center text-transform-uppercase'>
                                <i class='f7-icons size-16 line-height-icon-fix icon-ignition '></i> 
                            </div>`,
    },
    {
      Name: t('REPORT_ALERT_LIST_MSG18'),  //Ignition Off
      Value: '2',
      IconBg: 'bg-color-gray',
      Icon: 'icon-ignition',
      IconHTML: `<div class='user-icon text-align-center text-color-white bg-color-green display-flex align-items-center justify-content-center text-transform-uppercase'>
                                <i class='f7-icons size-16 line-height-icon-fix icon-ignition '></i> 
                            </div>`,
    },
  ]
}


export const permissionOptions = {
  ReplaceImei: 4,
  ActivateNewDevices: 32,
  SendAnyCommand: 1,
  EditAssetDetails: 8,
  DeactivateDevices: 64,
  ReplaceSims: 2,
  InstallationNotice: 16,
  SuspendDevice: 128,

}

export const FitmentOptionsEnum = {
  RemoteImmobilise: 1,
  AlarmIntegration: 2,
  SOSButton: 4,
  NotConnectedToIgnition: 8,
  FittedAfterIsolator: 16,
  EngineTheft: 32,
  Siren: 64,
  RemoteDoor: 512,
  DriverIDs: 2048,
}

export const alertStatuses = [
  { Name: 'NONE', Code: '0' },
  { Name: 'ACC', Code: '1' },
  { Name: 'Static', Code: '2' },
  { Name: 'Power', Code: '4' },
  { Name: 'Charging', Code: '8' },
  { Name: 'BeProtected', Code: '16' },
  { Name: 'ACC2', Code: '32' },
  { Name: 'Relay', Code: '64' },
  { Name: 'LowPower', Code: '256' },
  { Name: 'Input1', Code: '512' },
  { Name: 'Input2', Code: '128' },
  { Name: 'Input3', Code: '1024' },
  { Name: 'ForceSave', Code: '2097152' },
]

export const alertTypes = [
  { Name: 'LowTemp', Code: '4194304' },
  { Name: 'HighTemp', Code: '8388608' },
  { Name: 'Offline', Code: '67108864' },
  { Name: 'INPUT3', Code: '134217728' },
  { Name: 'HighSpeed', Code: '32' },
  { Name: 'Defence', Code: '8192' },
  { Name: 'Input1', Code: '131072' },
  { Name: 'Destroy', Code: '16384' },
  { Name: 'Theft', Code: '128' },
  { Name: 'ACCON', Code: '32768' },
  { Name: 'INPUT4', Code: '536870912' },
  { Name: 'FatigueDriving', Code: '16777216' },
  { Name: 'SOS', Code: '2' },
  { Name: 'INPUT2_LOW', Code: '1048576' },
  { Name: 'OutGeoFance', Code: '16' },
  { Name: 'LowPower', Code: '512' },
  { Name: 'ACCOFF', Code: '65536' },
  { Name: 'ElectricCutoff', Code: '4' },
  { Name: 'INPUT4_OFF', Code: '1073741824' },
  { Name: 'Moving', Code: '1024' },
  { Name: 'Vibrate', Code: '256' },
  { Name: 'INPUT3_OFF', Code: '268435456' },
  { Name: 'Accelerate', Code: '33554432' },
  { Name: 'Fire', Code: '2048' },
  { Name: 'InGeoFance', Code: '8' },
  { Name: 'Input2', Code: '262144' },
  { Name: 'INPUT1_LOW', Code: '524288' },
  { Name: 'None', Code: '0' },
  { Name: 'MedicalHelp', Code: '4096' },
  { Name: 'Custom', Code: '1' },
  { Name: 'HardBrake', Code: '2097152' },
  { Name: 'LowSpeed', Code: '64' },
]

export const ProductFeaturesEnum = {
  Input1: 16777216,
  Input2: 131072,

  Input3: 33554432,
  Input4: 67108864,
  Output1: 134217728,
  Output2: 268435456,

  Power: 128,
}

export const AdminPermissionsEnum = {
  AddIMEI: 2,
  DeleteIMEI: 4,
  InstallNotice: 32,
}

export const Permissions2Enum = {
  MonthlyAccountReport: 64,
}

export function openExternalUrl(href) {
  window.open(href, '_blank');
}

export function toLowerCaseObjectKeys(source) {
  return Object.keys(source)
    .reduce((destination, key) => {
      destination[key.toLowerCase()] = source[key];
      return destination;
    }, {});
}

export function isObjEmpty(obj) {
  // null and undefined are "empty"
  if (obj == null) return true;

  // Assume if it has a length property with a non-zero value
  // that that property is correct.
  if (obj.length > 0) return false;
  if (obj.length === 0) return true;

  // If it isn't an object at this point
  // it is empty, but it can't be anything *but* empty
  // Is it empty?  Depends on your application.
  if (typeof obj !== "object") return true;

  // Otherwise, does it have any properties of its own?
  // Note that this doesn't handle
  // toString and valueOf enumeration bugs in IE < 9
  for (let key in obj) {
    if (hasOwnProperty.call(obj, key)) return false;
  }
  return true;
}

export function sortArrayByObjProps(list, sortBy) {
  //sortBy.direction == 1  means asc
  //sortBy.direction == -1 means desc
  if (list && list.length) {
    list.sort(function (a, b) {
      let i = 0, result = 0;
      while (i < sortBy.length && result === 0) {
        result = sortBy[i].direction * (a[sortBy[i].prop].toString().toUpperCase() < b[sortBy[i].prop].toString().toUpperCase() ? -1 : (a[sortBy[i].prop].toString().toUpperCase() > b[sortBy[i].prop].toString().toUpperCase() ? 1 : 0));
        i++;
      }
      return result;
    })
  }
  return list;
}

export function getFormDataFromObject(query) {
  let data = new FormData();
  if (query && typeof query === 'object') {
    Object.keys(query).forEach(key => {
      if (Array.isArray(query[key])) {
        query[key].forEach(value => {
          data.append(`${key}[]`, value);
        });
      } else {
        data.append(key, query[key]);
      }
    });
  }
  return data;
}


// export function getFormDataFromObject(query) {
//   let data = new FormData();
//   if (!isObjEmpty(query)) {
//     const arr = Object.keys(query)
//     arr.forEach(element => {
//       if (Array.isArray(query[element])) {
//         for (let i = 0; i < query[element].length; i++) {
//           if (query[element][i]) data.append(element + '[]', query[element][i])
//         }
//       } else {
//         if (query[element] || query[element] === 0 || query[element] === false) data.append(element, query[element])
//       }
//     })
//   }
//   return data
// }

export function dateFormat(dateStr, outFormat = 'date', inFormat) {
  //const store = useStore()

  const options = {};
  if (outFormat.includes('date')) {
    options.day = '2-digit'
    options.month = '2-digit'
    options.year = 'numeric'
  }
  if (outFormat.includes('time')) {
    options.hour = '2-digit'
    options.minute = '2-digit'
    options.second = '2-digit'
  }

  const locale = store.getters.UserInfo.ContactInfo.Locale || 'en-US'
  return new Intl.DateTimeFormat(locale, options).format(new Date(dateStr || null))
}

export function directionText(direction) {
  const { t } = i18n.global
  direction = parseFloat(direction);
  let ret = t('COM_MSG029');
  switch (true) {
    case (direction >= 338 || direction <= 22):
      ret = t('COM_MSG021');
      break;
    case (direction >= 23 && direction <= 75):
      ret = t('COM_MSG022');
      break;
    case (direction >= 76 && direction <= 112):
      ret = t('COM_MSG023');
      break;
    case (direction >= 113 && direction <= 157):
      ret = t('COM_MSG024');
      break;
    case (direction >= 158 && direction <= 202):
      ret = t('COM_MSG025');
      break;
    case (direction >= 203 && direction <= 247):
      ret = t('COM_MSG026');
      break;
    case (direction >= 248 && direction <= 292):
      ret = t('COM_MSG027');
      break;
    case (direction >= 293 && direction <= 337):
      ret = t('COM_MSG028');
      break;
  }
  return ret
}

export function getParentUrl() {
  var isInIframe = (parent !== window),
    parentUrl = null;

  if (isInIframe) {
    parentUrl = document.referrer;
  }

  return parentUrl;
}

export function openAsCustomer(code) {
  const psl = require('psl');

  let mainUrl = 'cartrack.co' //quiktrak.co
  let parentUrl = getParentUrl()
  let url = !parentUrl ? mainUrl : parentUrl

  //remove protocols (http://, https://)
  url = url.replace(/(^\w+:|^)\/\//, '');
  //remove '/' from string ending
  if (url[url.length - 1] === '/') {
    url = url.slice(0, -1);
  }

  let parsedUrl = psl.parse(url)
  let urlSub = 'enduser'
  let urlSubNumberIndex = 7

  if (parsedUrl?.subdomain?.indexOf(urlSub) > -1) {
    let currentUrlSubNumber = parseInt(parsedUrl.subdomain[urlSubNumberIndex])
    urlSub += !currentUrlSubNumber ? 1 : ++currentUrlSubNumber
  }

  window.open(`https://${urlSub}.${mainUrl}/Default.aspx?code=${code}`, '_blank')
}

export function getDaysInMonth(y, m) {
  return new Date(y, m + 1, 0).getDate();
}

/*
* @rows - data as array
* @format - export file format, default 'xls'
* @name - file name
* @addTimeStamp - should date stamp be added to the file name
* */
export function exportTo(params) {
  let defaultParams = {
    name: moment().format('YYYY-MM-DD-HH-mm-ss'),
    format: 'xls',
  }
  if (!params.rows || !Array.isArray(params.rows) || !Array.isArray(params.rows[0])) {
    console.warn("add rows parameter, and it should be array with array data, exp. [['a','b','c'],['d','e','f']]")
    return
  }
  if (!params.name) {
    params.name = defaultParams.name
  } else if (params.name && params.addTimeStamp) {
    params.name += ' ' + defaultParams.name
  }

  var link = document.createElement("a");
  document.body.appendChild(link); // Required for FF
  link.setAttribute("class", 'external display-none');
  ExcellentExport.convert({
    anchor: link,
    //openAsDownload: true,
    filename: params.name,
    format: params.format || defaultParams.format,
  }, [{
    name: params.name,
    from: {
      array: params.rows
    }
  }]);
  link.click(); // This will download the data file named "my_data.csv".
  document.body.removeChild(link);
}

/*export function exportToPDF(params){
  let defaultParams = {
    name: moment().format('YYYY-MM-DD-HH-mm-ss'),
  }
  if(!params.name){
    params.name = defaultParams.name
  }else if(params.name && params.addTimeStamp){
    params.name += ' '+defaultParams.name
  }

  var generateData = function(rows, headers) {
    var result = [];

    rows.forEach( row => {
      let resRow = {}
      row.forEach( (val, index) => {
        resRow[headers[index]] = val
      })
      result.push(resRow)
    })
    return result;
  };

  function createHeaders(keys) {
    let result = [];
    for (var i = 0; i < keys.length; i += 1) {
      result.push({
        id: keys[i],
        name: keys[i],
        prompt: keys[i],
        width: 65,
        align: "center",
        padding: 0
      });
    }
    return result;
  }

  let rowHeader = params.rows.shift()
  let headers = createHeaders(rowHeader)
  let data = generateData(params.rows, rowHeader)

  let doc = new jsPDF({ putOnlyUsedFonts: true, orientation: "landscape" });
  doc.table(1, 1, data, headers, { autoSize: true });
  doc.save(`${ params.name }.pdf`);
}*/

export function exportToPDF(params) {
  let defaultParams = {
    name: moment().format('YYYY-MM-DD-HH-mm-ss'),
    pageOrientation: 'landscape',
    pageSize: 'A3',
  }
  if (!params.name) {
    params.name = defaultParams.name
  } else if (params.name && params.addTimeStamp) {
    params.name += ' ' + defaultParams.name
  }
  function createHeaders(row) {
    let result = []
    row.forEach(val => {
      result.push({
        text: val,
        style: 'tableHeader'
      })
    })
    return result
  }

  var docDefinition = {
    content: [
      {
        style: 'qtTable',
        table: {
          body: [
            createHeaders(params.rows.shift()),
            ...params.rows
          ]
        },
        layout: {
          fillColor: function (rowIndex, node, columnIndex) {
            return (rowIndex % 2 === 0) ? '#CCCCCC' : null;
          }
        }
      },
    ],
    pageOrientation: params.pageOrientation || defaultParams.pageOrientation,
    pageSize: params.pageSize || defaultParams.pageSize,
    styles: {
      qtTable: {
        fontSize: 8,
        margin: [0, 5, 0, 5]
      },
      tableHeader: {
        bold: true,
        fontSize: 10,
        color: 'black',
        alignment: 'center'
      }
    },
    defaultStyle: {
      //alignment: 'justify'
    }
  }

  var pdf = pdfmake.createPdf(docDefinition);
  pdf.download(`${params.name}.pdf`)
}

// Copies a string to the clipboard. Must be called from within an
// event handler such as click. May return false if it failed, but
// this is not always possible. Browser support for Chrome 43+,
// Firefox 42+, Safari 10+, Edge and Internet Explorer 10+.
// Internet Explorer: The clipboard feature may be disabled by
// an administrator. By default a prompt is shown the first
// time the clipboard is used (per session).
export function copyToClipboard(text) {
  if (window.clipboardData && window.clipboardData.setData) {
    // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
    return window.clipboardData.setData("Text", text);

  }
  else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
    var textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in Microsoft Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
      return document.execCommand("copy");  // Security exception may be thrown by some browsers.
    }
    catch (ex) {
      console.warn("Copy to clipboard failed.", ex);
      return false;
    }
    finally {
      document.body.removeChild(textarea);
    }
  }
}



export const roleList = [
  { Name: 'None', Code: '0' },
  { Name: 'Admin', Code: '1' },
  { Name: 'Client', Code: '2' },
  { Name: 'Monitor', Code: '3' },
  { Name: 'Installer', Code: '4' },
  { Name: 'Driver', Code: '5' },
  { Name: 'User', Code: '6' },
  { Name: 'Visitor', Code: '7' },
  { Name: 'Support', Code: '8' },
  { Name: 'Visitor2', Code: '9' },
  { Name: 'Loc8ViewOnly', Code: '10' },
  { Name: 'Loc8FullAccess', Code: '11' },
]

export const creditList = [
  { Name: '100', Value: 100 },
  { Name: '500', Value: 500 },
  { Name: '1000', Value: 1000 },

]



export const stateList = [
  { Name: 'ON', Code: 1 },
  { Name: 'OFF', Code: 0 },

]


export const uiList = [
  { Name: 'UI Track', Code: '0' },
  { Name: 'UI Loc8', Code: '1' },

]
export const accountList = [
  { Name: 'N/a', Code: '0' },
  { Name: 'Cartrack', Code: '1' },

]




export const sheduleList = [
  { Name: 'N/a', Code: '0' },
  { Name: '1', Code: '1' },
  { Name: '2', Code: '2' },
  { Name: '3', Code: '3' },
  { Name: '4', Code: '4' },
  { Name: '5', Code: '5' },
  { Name: '6', Code: '6' },
  { Name: '7', Code: '7' },
  { Name: '8', Code: '8' },
  { Name: '9', Code: '9' },
  { Name: '10', Code: '10' },
  { Name: '11', Code: '11' },
  { Name: '12', Code: '12' },
  { Name: '13', Code: '13' },
  { Name: '14', Code: '14' },
  { Name: '15', Code: '15' },
  { Name: '16', Code: '16' },
  { Name: '17', Code: '17' },
  { Name: '18', Code: '18' },
  { Name: '19', Code: '19' },
  { Name: '20', Code: '20' },
  { Name: '21', Code: '21' },
  { Name: '22', Code: '22' },
  { Name: '23', Code: '23' },
  { Name: '24', Code: '24' },
  { Name: '25', Code: '25' },
  { Name: '26', Code: '26' },
  { Name: '27', Code: '27' },
  { Name: '28', Code: '28' },
  { Name: '29', Code: '29' },

]


export function setInStorage(params) {

  let self = this;
  if (typeof (params) == 'object' && params.name) {
    switch (params.name) {


      case 'assetList':
        localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.ASSETLIST", JSON.stringify(params.data))
        break;
      case 'userInfo':



        localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.USERINFO", JSON.stringify(params.data));
        break;

      case 'groupList':
        localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.GROUPLIST", JSON.stringify(params.data));
        break;

      case 'contactList':
        localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.CONTACTLIST", JSON.stringify(params.data));
        break;

      case 'usersList':
        localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.USERSLIST", JSON.stringify(params.data));
        break;

      case 'geofenceList':
        localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.GEOFENCELIST", JSON.stringify(params.data));
        break;

      case 'intervalRemindersList':
        localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.INTERVALREMINDERS", JSON.stringify(params.data));
        break;


      case 'historyArray':
         var HistoryArray = parsePlaybackHystoryArr(params.data);

        localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.HISTORYARRAY", JSON.stringify(HistoryArray));
        break;

      case 'historyEvents':
        var EventsArray = parsePlaybackEventsArr(params.data);

        localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.EVENTSARRAY", JSON.stringify(EventsArray));
        break;

      case 'reportData':
        localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.REPORTDATA", JSON.stringify(params.data));
        break;

      case 'dashboard':
        localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.DASHBOARD", JSON.stringify(params.data));
        break;

      case 'solutions':
        localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.SOLUTIONS", JSON.stringify(params.data));
        break;

      case 'alertList':
        $.ajax({
          type: "POST",
          url: "../resources/php/set.php",
          dataType: 'json',
          data: JSON.stringify({ storage_data: params.data }),
          async: true,
          cache: false,
          beforeSend: function () {

          },
          success: function (data) {
            console.log('set data to ' + params.name)
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            console.log(XMLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
          }
        });

        //localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.ALERTLIST", JSON.stringify(params.data));
        break;

      case 'scheduledReportList':
        localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.SCHEDULEDREPORTS", JSON.stringify(params.data));
        break;

      case 'mapSettings':
        localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.MAPSETTINGS", JSON.stringify(params.data));
        break;
      case 'otherSettings':
        localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.OTHERSETTINGS", JSON.stringify(params.data));
        break;
      case 'assetTypes':
        localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.ASSETTYPES", JSON.stringify(params.data));
        break;
      case 'userAlarmSettings':
        localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.USERALARMSETTINGS", JSON.stringify(params.data));
        break;
      case 'permissions2':
        localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.PERMISSIONS2", JSON.stringify(params.data));
        break;

      default:
        self.dialog.alert('There is no function associated with this name - ' + params.name);
    }
  } else {
    self.dialog.alert('Wrong query parameters!');
    console.log(params);
  }
}


export function getFromStorage(name) {
  var ret = [];
  var str = '';
  if (name) {
    switch (name) {



      case 'userInfo':
        str = localStorage.getItem("COM.QUIKTRAK.QUIKLOC8.USERINFO");
        if (str) {
          ret = JSON.parse(str);
        }
        break;

      case 'assetList':
        str = localStorage.getItem("COM.QUIKTRAK.QUIKLOC8.ASSETLIST");
        if (str) {
          ret = JSON.parse(str);
        }
        break;

      case 'groupList':
        str = localStorage.getItem("COM.QUIKTRAK.QUIKLOC8.GROUPLIST");
        if (str) {
          ret = JSON.parse(str);
        }
        break;

      case 'usersList':


        str = localStorage.getItem("COM.QUIKTRAK.QUIKLOC8.USERSLIST");
        if (str) {
          ret = JSON.parse(str);
        }
        break;

      case 'contactList':
        str = localStorage.getItem("COM.QUIKTRAK.QUIKLOC8.CONTACTLIST");
        if (str) {
          ret = JSON.parse(str);
        }
        break;


      case 'geofenceList':
        str = localStorage.getItem("COM.QUIKTRAK.QUIKLOC8.GEOFENCELIST");
        if (str) {
          ret = JSON.parse(str);
        } else {
          ret = {};
        }
        break;

      case 'intervalRemindersList':
        str = localStorage.getItem("COM.QUIKTRAK.QUIKLOC8.INTERVALREMINDERS");
        if (str) {
          ret = JSON.parse(str);
        } else {
          ret = {};
        }
        break;


      case 'notifications':
        str = localStorage.getItem("COM.QUIKTRAK.QUIKLOC8.NOTIFICATIONS");
        if (str) {
          ret = JSON.parse(str);
          console.log(str)
        } else {
          ret = {};
        }
        break;

      case 'permissions2':
        str = localStorage.getItem("COM.QUIKTRAK.QUIKLOC8.PERMISSIONS2");
        if (str) {
          ret = JSON.parse(str);
        }
        break;

      case 'historyArray':
        str = localStorage.getItem("COM.QUIKTRAK.QUIKLOC8.HISTORYARRAY");
        if (str) {
          ret = JSON.parse(str);
        }
        break;

      case 'historyEvents':
        str = localStorage.getItem("COM.QUIKTRAK.QUIKLOC8.EVENTSARRAY");
        if (str) {
          ret = JSON.parse(str);
        }
        break;

      case 'reportData':
        str = localStorage.getItem("COM.QUIKTRAK.QUIKLOC8.REPORTDATA");
        if (str) {
          ret = JSON.parse(str);
        }
        break;

      case 'dashboard':
        str = localStorage.getItem("COM.QUIKTRAK.QUIKLOC8.DASHBOARD");
        if (str) {
          ret = JSON.parse(str);
        } else {
          ret = {};
        }
        break;

      case 'solutions':
        str = localStorage.getItem("COM.QUIKTRAK.QUIKLOC8.SOLUTIONS");
        if (str) {
          ret = JSON.parse(str);
        }
        break;

      case 'alertList':
        $.ajax({
          type: "POST",
          url: "../resources/php/get.php",
          dataType: 'json',
          data: {},
          async: true,
          cache: false,
          beforeSend: function () {

          },
          success: function (data) {
            console.log(data)
            if (data) {
              ret = JSON.parse(data.data[0].storage_data);
              console.log(ret)
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            console.log(XMLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
          }
        });
        /*str = localStorage.getItem("COM.QUIKTRAK.QUIKLOC8.ALERTLIST");
                    if (str) {
                        ret = JSON.parse(str);
                    }*/
        break;

      case 'scheduledReportList':
        str = localStorage.getItem("COM.QUIKTRAK.QUIKLOC8.SCHEDULEDREPORTS");
        if (str) {
          ret = JSON.parse(str);
        }
        break;

      case 'mapSettings':
        str = localStorage.getItem("COM.QUIKTRAK.QUIKLOC8.MAPSETTINGS");
        if (str) {
          ret = JSON.parse(str);
        } else {
          ret = {};
        }
        break;

      case 'otherSettings':
        str = localStorage.getItem("COM.QUIKTRAK.QUIKLOC8.OTHERSETTINGS");
        if (str) {
          ret = JSON.parse(str);
        } else {
          ret = {};
        }
        break;

      case 'assetTypes':
        str = localStorage.getItem("COM.QUIKTRAK.QUIKLOC8.ASSETTYPES");
        if (str) {
          ret = JSON.parse(str);
        }
        break;

      case 'userAlarmSettings':
        str = localStorage.getItem("COM.QUIKTRAK.QUIKLOC8.USERALARMSETTINGS");
        if (str) {
          ret = JSON.parse(str);
        } else {
          ret = {};
        }
        break;

      default:
        self.dialog.alert('There is no item saved with such name - ' + name);
    }
  } else {
    self.dialog.alert('Wrong query parameters!');
    console.log(name);
  }
  return ret;
}